var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containerVideo"},_vm._l((_vm.slides),function(video){return _c('AppVideoPlayer',{key:video.id,ref:video.id,refInFor:true,attrs:{"video":video}})}),1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9364128a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/vuejs/frontend/2023-launch/components/VideoTogglePlayer.vue
// module id = mQJj
// module chunks = 4